import { useCallback, useState } from 'react';
import { getSessionStorageItem } from 'shared/utils/session-storage';

const BASE_STORAGE_KEY = 'new-mail-draft';

type Draft = { id: string; threadId: string };

// Scope per debtor so a draft started from the generic mail-index compose never
// bleeds into (or gets overwritten by) one started from a client/debtor page.
export const getStorageKey = (baseKey: string, debtorId?: string) =>
  debtorId ? `${baseKey}-${debtorId}` : baseKey;

export const usePersistedDraft = (debtorId?: string) => {
  const storageKey = getStorageKey(BASE_STORAGE_KEY, debtorId);

  const [draft, setDraftState] = useState<Draft | null>(() =>
    getSessionStorageItem<Draft | null>(storageKey, null),
  );

  const setDraft = useCallback(
    (value: Draft | null) => {
      if (value) window.sessionStorage.setItem(storageKey, JSON.stringify(value));
      else window.sessionStorage.removeItem(storageKey);
      setDraftState(value);
    },
    [storageKey],
  );

  return { draft, setDraft };
};
